<template>
  <div class="api-filters-tab">
    <ApiTabEmptyState
      title="No filters yet"
      description="Create a filter to control exactly which of your populations and partner populations the API returns. Your filters and their IDs will appear here."
      create-cta-text="Create filter"
      :icon="['fak', 'filter']"
    />
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

import ApiTabEmptyState from '../components/ApiTabEmptyState.vue';

useHead({ title: 'API Filters - Crossbeam' });
</script>
